import { contentCards$ } from '../../repositories/content-cards/content-cards.repository';
import { NotificationCardComponent } from '../notification-card/notification-card.component';
import { sample } from '../../utils/sample';
import { mapContentCardsToNotificationCards } from '../../utils/map-content-cards-to-notification-cards';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'braze-card-viewer',
  templateUrl: './braze-card-viewer.component.html',
  styleUrls: ['./braze-card-viewer.component.scss'],
  imports: [TranslocoModule, NotificationCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrazeCardViewerComponent {
  @HostBinding('class.d-none') get hide() {
    return this.notificationCards().length === 0;
  }
  notificationCards = toSignal(
    contentCards$.pipe(
      map((cards) => cards.filter(({ dismissed }) => !dismissed)),
      map((cards) => mapContentCardsToNotificationCards(cards)),
      map((cards) => sample(cards, 2))
    ),
    {
      initialValue: [],
    }
  );
}
